// extracted by mini-css-extract-plugin
export var cyan = "CollapsableDescription-module--cyan--2a046";
export var red = "CollapsableDescription-module--red--3387e";
export var root = "CollapsableDescription-module--root--a1452";
export var showButton = "CollapsableDescription-module--showButton--a6f8a";
export var showMore = "CollapsableDescription-module--showMore--302ad";